<app-widget-home-core
  [widget]="widget"
  [isStoreView]="isStoreView"
  [subheader]="('COMMON.TODAY' | translate) + (local ? ' | ' + local : '')"
  (click)="onClickWidget()"
>

  <app-widget-principal-data
    [label]="'WIDGETS.HOME.WAREHOUSE.INVENTORY_TO_DO' | translate"
    [data]="widgetData"
    [showData]="loadedData || isStoreView"
  ></app-widget-principal-data>

</app-widget-home-core>
